import { serverUrlToken } from 'shared';
import { environment } from '../../environments/environment';

export const serverUrlProvider = {
  provide: serverUrlToken,
  useValue: environment.serverUrl
};
